import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import TitleBar from '../TitleBar'
import UserRow from '../Users/UserRow'
import getLabel from '../../utilities/label.js'
import { deviceDetect } from 'react-device-detect'
import './buttonSlider.css'
import './modalStyles.css'
import { outerStyle, imgStyle, deviceInfoStyle, formStyle, supportButton } from './styles.js'

export default class SettingsAndSupport extends Component {
  constructor(props) {
    super(props)
    const agent = deviceDetect(window.navigator.userAgent)
    const device = agent?.osName?.concat(' ')?.concat(agent?.osVersion)
    const browser = agent?.browserName?.concat(' ')?.concat(agent?.browserFullVersion)
    this.state = {
      device: device,
      browser: browser,
      showConfirmationModal: false
    }
    window.trackPage('SettingsAndSupport')
  }

  getProgramManager() {
    return this.props.users.event_users.find((user) => {
      return user.is_pm
    })
  }

  marketingUrl() {
    const hostname = window && window.location && window.location.hostname
    if(hostname === 'localhost') {
      return 'http://localhost:1199/'
    } else if (hostname === 'stage-events.evanta.com' ) {
      return 'https://stage.evanta.com/'
    } else {
      return 'https://www.evanta.com/'
    }
  }


  render() {
    const pm = null
    return (
      <div>
        <TitleBar
          title={ getLabel({ key: 'setting', plural: true }) }
          leftButtonLabel={ this.props.backButton }
          leftButtonAction={() => window.history.back()}
        />
        <div style={ outerStyle }>
          <img
            src="/gartner_c_level_communities_color.svg" alt=""
            style={ imgStyle } />
        </div>
        <div style={ deviceInfoStyle }>{ getLabel('device_model') }: { this.state.device } | { this.state.browser }</div>
        { pm &&
          <div style={ formStyle }>
          	<h4>{ getLabel('event_program_manager')}</h4>
          	<UserRow user={ pm } />
          </div>
        }
        <div style={ formStyle }>
          <h4 style={{ marginTop: '20px' }}>{ getLabel('support')}</h4>
          <Link to="/contact_form">
            <button style={ supportButton }>
              { getLabel('contact_support') }
            </button>
          </Link>
          <button
            onClick={ this.props.refreshData }
            style={ supportButton }>
            { getLabel('refresh_all') }
          </button>
          <Link
            to={{
              pathname: '/change_password',
              state: { requireCurrentPw: true}
            }}
          >
            <button style={ supportButton }>
              { getLabel('change_password') }
            </button>
          </Link>
        </div>
        <div style={ formStyle }>
          <h4 style={{ marginTop: '20px' }}>{ getLabel('legal_header')}</h4>
          <a
            target="_blank"
            rel="noopener noreferrer"
            href={ this.marketingUrl() + 'terms/terms_and_conditions' }>
            <button style={ supportButton }>
              { getLabel('terms_and_conditions') }
            </button>
          </a>
          <a
            target="_blank"
            rel="noopener noreferrer"
            href={ this.marketingUrl() + 'terms/privacy_policy' }>
            <button style={ supportButton }>
              { getLabel('privacy_policy') }
            </button>
          </a>
          <a
            target="_blank"
            rel="noopener noreferrer"
            href={ this.marketingUrl() + 'terms/leaderboard_rules' }>
            <button style={ supportButton }>
              { getLabel('official_leaderboard_rules') }
            </button>
          </a>
          <a
            target="_blank"
            rel="noopener noreferrer"
            href={ this.marketingUrl() + 'terms/sweepstakes_rules' }>
            <button style={ supportButton }>
              { getLabel('official_sweepstakes_rules') }
            </button>
          </a>
        </div>
      </div>
    )
  }
}
